import React, { Suspense } from 'react';
import Loading from 'components/Loading';

const Logs = React.lazy(() => import('./Logs'));

export default function LogsCollection(props) {
  return (
    <Suspense fallback={<Loading />}>
      <Logs {...props} />
    </Suspense>
  );
}
